import React from "react";

import * as Styles from "./styles";

interface Props {
  open: boolean;
  isRight?: "absolute" | "relative";
  height?: number | "auto";
  setOpenModal: (val: boolean) => void;
  onClose: () => void;
  children: React.ReactNode;
}

const ModalFulscreen: React.FC<Props> = (props) => {
  return (
    <Styles.Modal
      fullScreen
      open={props?.open}
      onClose={(event, reason) => {
        props?.setOpenModal(false);
        props?.onClose();
      }}
    >
      {props?.children}
    </Styles.Modal>
  );
};

export default ModalFulscreen;
